import { Locales } from '@ratehub/base-ui';

import withEnglishLocale from '../functions/withEnglishLocale';
import createBlogPostStaticProps from '../functions/createBlogPostStaticProps';
import BLOCK_MAP from '../definitions/TemplateBlogPostBlockMap';
import createStaticWordpressPage from '../functions/createStaticWordpressPage';


const { getStaticPaths, getStaticProps } = createBlogPostStaticProps({
    locale: Locales.ENGLISH,
    fileName: 'blogPostsEN', // Must match filename use for catch all, i.e. [...ccDetailsSlugEN].jsx
    path: '/blog', // Array to determine the url - final result is `/${rootPath.join('/')}`
    blockMap: BLOCK_MAP,
});

const page = createStaticWordpressPage({ blockMap: BLOCK_MAP });

export default withEnglishLocale(page);
export { getStaticPaths, getStaticProps };
